import React, { useCallback, useEffect, useState } from 'react'
import { useAnimate, motion, useAnimation, easeIn } from "framer-motion";
import { useAnimationSeqContext } from '../ContextProviders/AnimationSeqContextProvider';

import gameConfig from '../gameConfig';
import { useGameStateContext } from '../ContextProviders/GameStateContextProvider';

function ReelSymbol({ reel, row, symbolNo, spinning }) {
    const aControl = useAnimation();
    const reelAnimation = useAnimation();
    const [scope, animate] = useAnimate();
    const gameState = useGameStateContext();
    const [isSpinning, setIsSpinning] = useState(false);

    const sequence = [
        [scope.current, { y: +80 }, { duration: 0.5 }],
        [scope.current, { y: -80 }, { duration: 0.0 }],
        [scope.current, { y: +80 }, { duration: 0.5 }],
        [scope.current, { y: -80 }, { duration: 0.0 }],
    ]

    const getReelAnimationVariants = useCallback(() => {
        const y = [null, 80 * (gameConfig.rows - row), -80 * (row + 1)]
        return {
            startSpin: (reel) => ({
                y: y,
                //backgroundColor: 'rgba(0,0,0,0)',
                transition: {
                    times: [0, 1, 1],
                    ease: 'linear',
                    duration: 0.1 * (gameConfig.rows - row),
                    delay: 0.2 * reel
                },
                backgroundColor: 'rgba(0,0,0,0)'
            }),
            doSpin: {
                y: [80 * (gameConfig.rows - row), -80 * (row + 1)],
                transition: {
                    times: [1, 0],
                    duration: 0.4,
                    ease: 'linear',
                    repeat: Infinity
                },
            },
            stopSpin: {
                y: [null, 0],
                transition: {
                    duration: 0.2,
                    type: "spring",
                    stiffness: 750,
                },
            },
            pop: {
                scale: [null, 0.8, 1.4, 1.4, 1.0],
                rotate: [null, 0, -10, 10, 0],
                backgroundColor: [null, 'rgba(255,50,50,0.5)', 'rgba(255,50,50,0.5)', 'rgba(255,50,50,0.5)'],
                transition: {
                    times: [0, 0.1, 0.2, 0.3, 1],
                    duration: 1.5,
                    delay: 1,
                    //type: ["spring", "spring", "spring", "spring"],
                    //stiffness: [750,750,750,750]
                }
            },
            reset: {
                backgroundColor: 'rgba(0,0,0,0)'
            }
        }
    }, [row]);
    const reelAnimVariants = getReelAnimationVariants();
    const doAnimation = async (data) => {
        const d = async (time) => {
            return new Promise(res => {
                setTimeout(res, time)
            })
        }

        console.log("Do Win Seq Animation")
        if (data?.type === 'lineWin') {
            let delaytime = data.win.positions.findIndex((e) => (e.reel === reel && e.row === row))
            if (delaytime >= 0) {
                await d(delaytime * 300)
                await reelAnimation.start("pop");
            }
        } else if (data?.type === 'jackpotMatches') {
            if (data.matches !== null && data.matches != undefined && data.matches[row][reel].length > 0) {
                var color = gameConfig.colors.jackpots[data.matches[row][reel][0]];
                var color2 = gameConfig.colors2.jackpots[data.matches[row][reel][0]];
                //aVariants.match.backgroundColor = [null, color, color]
                //await aControl.start("match");

                await reelAnimation.start({
                    backgroundColor: [null, color2, color],
                    //scale: [null, 1.2, 1.0],
                    transition: {
                        times: [0, 0.1, 1],
                        duration: 1.5,
                        delay: 1,
                    }
                }
                );
            }
        } else if (data?.type === 'reset') {
            //await reelAnimation.start("reset");
        }
    }



    const animationSeqCtx = useAnimationSeqContext();
    var aVariants = {
        initial: {
            y: -80,
            opacity: 0,
            //filter: "blur(10px)",
        },
        stopped: {
            y: 0,
            opacity: 1,
            transition: {
                duration: 0.2,
                type: "spring",
                stiffness: 750,
                staggerChildren: 1,
                //staggerDirection: -1,

                //delay: i/10 
            },
            //filter: "blur(0px)" 
        },
        stopStart: {
            y: +80,
            opacity: 0,
            //filter: "blur(10px)",
            transtion: {
                type: "easeIn"
            }
        },
        pop: {
            scale: [null, 0.8, 1.4, 1.4, 1.0],
            rotate: [null, 0, -10, 10, 0],
            backgroundColor: [null, 'rgba(255,50,50,0.5)', 'rgba(255,50,50,0.5)', 'rgba(255,50,50,0)'],
            transition: {
                times: [0, 0.1, 0.2, 0.3, 1],
                duration: 1.5,
                delay: 1,
                //type: ["spring", "spring", "spring", "spring"],
                //stiffness: [750,750,750,750]
            }
        },
        match: {
            //scale: [null, 0.8, 1.4, 1.4, 1.0],
            //rotate: [null, 0, -10, 10, 0],
            backgroundColor: [null, 'rgba(50,255,50,1.0)', 'rgba(50,255,50,0.5)'],
            transition: {
                times: [0, 0.1, 0.2, 1],
                duration: 1.5,
                delay: 1,
                //type: ["spring", "spring", "spring", "spring"],
                //stiffness: [750,750,750,750]
            }
        },
        reset: {
            backgroundColor: 'rgba(0,0,0,0)'
        }
    }

    const doSpinAnimation = async (spinning) => {
        var isLocked = gameState.activeLocks.includes(reel);
        if (spinning && !isLocked) {

            setIsSpinning(true);
            if (row === 1) {
                const audio = new Audio(`${process.env.PUBLIC_URL}/Sounds/clicking.mp3`);
                audio.volume = 0.3;
                setTimeout(() => audio.play(), 200 * reel);
            }
            await reelAnimation.start("startSpin");
            reelAnimation.start("doSpin");

            setTimeout(() => { setIsSpinning(false) }, 5000);
            await new Promise(resolve => setTimeout(resolve, 2000));
            reelAnimation.start("stopSpin")
        }
        return;
        const d = async (time) => {
            return new Promise(res => {
                setTimeout(res, time)
            })
        }

        await d(100 * reel);
        if (spinning) {

            animate(sequence);
            if (!gameState.activeLocks.includes(reel))
                aControl.start("stopStart");
        }
        else {
            if (!gameState.activeLocks.includes(reel)) {
                aControl.set("initial");
                aControl.start("stopped");
            }
        }
    }

    useEffect(() => {
        doSpinAnimation(spinning);
    }, [aControl, spinning])

    useEffect(() => {
        animationSeqCtx.register("ReelSymbol " + reel + " " + row, 1, doAnimation)

        animate(sequence)
    }, []);
    const imagePath = `${process.env.PUBLIC_URL}/Images/${symbolNo}.png`;
    return (
        <motion.div
            className="symbol"
            ref={scope}
            //key={k++}
            width="92px"
            height="82px"
            position="absolute"
            style={{
                //backgroundImage: `url(${process.env.PUBLIC_URL}/Images/${symbolNo}.png) `,
                //background: 'linear-gradient(to top, rgba(0, 0, 0, 0), rgba(255, 255, 255, 0.5))',
                //backgroundImage: `url(${process.env.PUBLIC_URL + '/Images/1.png'})`,
                //width: '100%',
                //height: '100%',
                //width: '92px',
                //height: '82px',
                borderRadius: "20%",
                margin: '2px'
            }}
            variants={reelAnimVariants}
            animate={reelAnimation}
            custom={reel}

            onClick={() => {
                gameState.setLock(reel, !gameState.getLock(reel));
            }}
        //initial="initial"
        //transition={{ repeat: Infinity}}
        //initial={{y:-100, opacity: 0}}
        //animate={{ y: 0, opacity: 100 }}
        //transition={{ duration: 0.2, type: "spring", stiffness: 750, delay: i/10 }}
        >
            <img width="90%" src={imagePath} /></motion.div>

    )
}

export default ReelSymbol